/**
 * Copyright 2025 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import { getKiboDecisionFlag, useMonetateDecisionFlag } from '@/features/kibo/api/getKiboDecision';
import { type QueryClient } from '@tanstack/react-query';

type OMSFlags = {
  useOMSInventoryQohService: boolean;
};

/**
 * Retrieves OMS (Order Management System) feature flags fetched from Monetate in the query client.
 *
 * @param queryClient - The React Query client instance used to fetch feature flags
 * @returns An object containing OMS feature flags
 * @throws Error when queryClient is undefined
 */
export const getOMSFlags = (queryClient: QueryClient | undefined): OMSFlags => {
  if (!queryClient) {
    throw new Error('Monetate config is undefined');
  }
  const useOMSInventoryQohService = getKiboDecisionFlag(queryClient, 'useOMSInventoryQohService');

  return {
    useOMSInventoryQohService,
  };
};

export const useOMSFlags = () => {
  const useOMSInventoryQohService = useMonetateDecisionFlag('useOMSInventoryQohService');

  return {
    useOMSInventoryQohService,
  };
};
